export default __webpack_public_path__ + "static/aboutinterview-387ab64fbcdd8b4622f855db6cd4d09b.jpg";